<template>
  <div class="invite-tenders-list-container">
    <div class="invite-text-container">
      <div class="invite-title-banner">
        <span class="left-title">{{ item.purchaseName }}</span>
        <!-- <span class="right-icon">
                现场签证
                </span> -->
      </div>
      <div class="invite-text-content">
        <span>项目公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div class="invite-text-content">
        <span>所属项目：</span>
        <span>{{ item.projname }}</span>
      </div>
      <div class="invite-text-content">
        <span>发布时间：</span>
        <span>{{
          item.releaseDate && moment(item.releaseDate).format('YYYY-MM-DD')
        }}</span>
      </div>
    </div>
    <div class="steps-content">
      <steps-line :step="step"></steps-line>
    </div>
  </div>
</template>

<script>
import stepsLine from '../../../components/steps-line-cp';
import moment from 'moment';
export default {
  name: 'invite-tenders-list',

  data() {
    return {
      moment,
      step: {}
    };
  },
  mounted() {},

  components: {
    stepsLine
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    let { item } = this;
    this.step = {
      hbEnddate: item.hbEnddate && moment(item.hbEnddate).format('YYYY-MM-DD'),
      dyEnddate: item.dyEnddate && moment(item.dyEnddate).format('YYYY-MM-DD'),
      progressState: item.progressState,
      responderState: item.responderState
    };
    // console.log(this.item)
  },
  methods: {},
  watch: {
    item: {
      handler() {},
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.invite-tenders-list-container {
  background: white;
  margin-top: 20px;
  padding-bottom: 20px;
  .steps-content {
    height: 148px;
    display: flex;
    padding: 20px;
  }
  .invite-text-container {
    padding: 20px;
    .invite-title-banner {
      position: relative;
      .left-title {
        width: 83%;
        color: #000000;
        font-size: 32px;
        display: inline-block;
      }
      .right-icon {
        width: 120px;
        height: 40px;
        font-size: 22px;
        color: white;
        line-height: 40px;
        text-align: center;
        background: #36c490;
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
    .invite-text-content {
      color: #666666;
      font-size: 26px;
      margin-top: 20px;
      span:nth-child(2) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.invite-tenders-list-container {
}
</style>
